import React from 'react';
import PatientInfoStack from 'Routes/Protected/CurrentPatients/Components/EachPatient/component/PatientInfoStack';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';

const FileReportSummaryTrigger = ({
  setOpenSummaryInput,
  documentSummaryList
}) => {
  const imgHeader = 'data:image/svg+xml;base64,';
  const fileReport_summurary = FindLangKey(
    'current-patients-patient-actions-service-summary'
  );
  const cachedIcons = JSON.parse(
    localStorage.getItem('icons')
  );
  const fileReport_summurary_image =
    imgHeader +
    cachedIcons?.MenueIcon['Summary Case.svg'];


    const dataNotFound = FindLangKey('general-public-flat-alert-no-data');

  return (
    <React.Fragment>
      <div
        style={{
          fontWeight: 'bold',
          cursor: 'pointer',
          alignSelf: 'flex-end',
        }}
        onClick={() => {
          if(documentSummaryList?.length === 0){
            SwalAlert('info',dataNotFound,false)
          }
          setOpenSummaryInput((prev) => !prev);
        }}
      >
        <PatientInfoStack
          ImageSource={fileReport_summurary_image}
          paragraph={fileReport_summurary}
        />
      </div>
    </React.Fragment>
  );
};

export default FileReportSummaryTrigger;
